import React from 'react';
import PropTypes from 'prop-types';

export default class AsyncComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            component: null,
        };
    }

    async componentDidMount() {
        const { default: component } = await this.props.importComponent();
        this.setState({ component }); // eslint-disable-line react/no-did-mount-set-state
    }

    render() {
        const C = this.state.component;
        const { children, ...other } = this.props;

        return C ? <C {...other} /> : children || null;
    }
}

AsyncComponent.propTypes = {
    importComponent: PropTypes.func.isRequired,
    children: PropTypes.object,
};
